'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonCta = require('../../01.atoms/ButtonCta/ButtonCta.js');
var ListItem = require('../../01.atoms/ListItem/ListItem.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-result-list',
    cnHeader = "".concat(CLASSNAME, "__header"),
    cnHeaderOut = "".concat(cnHeader, " ").concat(cnHeader, "--out"),
    cnList = "".concat(CLASSNAME, "__list"),
    cnListItem = "".concat(CLASSNAME, "__list-item"),
    cnButtonWrapper = "".concat(CLASSNAME, "__button-wrapper");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function ResultList(_ref) {
  var buttonLabel = _ref.buttonLabel,
      className = _ref.className,
      itemsIn = _ref.itemsIn,
      itemsOut = _ref.itemsOut,
      listRef = _ref.listRef,
      onHover = _ref.onHover,
      onIncreaseDistance = _ref.onIncreaseDistance,
      resultMessageIn = _ref.resultMessageIn,
      resultMessageOut = _ref.resultMessageOut;
  var allItems = itemsIn.length;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(className, CLASSNAME)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnHeader
  }, /*#__PURE__*/React__default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: resultMessageIn.replace('${count}', allItems)
    }
  }), allItems ? ':' : ''), /*#__PURE__*/React__default.createElement("ul", {
    className: cnList,
    ref: listRef
  }, itemsIn.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(ListItem, {
      className: cnListItem,
      key: item.key || index,
      type: item.type,
      dealerDistance: item.dealerDistance,
      dealerName: item.dealerName,
      dealerAddress: item.dealerAddress,
      dealerZip: item.dealerZip,
      dealerPhone: item.dealerPhone,
      onClick: item.onClick,
      onMouseEnter: function onMouseEnter() {
        return onHover(item.key);
      },
      onMouseLeave: function onMouseLeave() {
        return onHover();
      }
    });
  }), itemsOut.length ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: cnHeaderOut
  }, /*#__PURE__*/React__default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: resultMessageOut
    }
  }), ":"), /*#__PURE__*/React__default.createElement("div", {
    className: cnButtonWrapper
  }, /*#__PURE__*/React__default.createElement(ButtonCta, {
    tagName: "button",
    title: buttonLabel,
    icon: "arrow-circle-left",
    onClick: onIncreaseDistance
  }))) : null, itemsOut.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(ListItem, {
      className: cnListItem,
      key: item.key || index,
      type: item.type,
      dealerDistance: item.dealerDistance,
      dealerName: item.dealerName,
      dealerAddress: item.dealerAddress,
      dealerPhone: item.dealerPhone,
      onClick: item.onClick,
      onMouseEnter: function onMouseEnter() {
        return onHover(item.key);
      },
      onMouseLeave: function onMouseLeave() {
        return onHover();
      }
    });
  })));
}
ResultList.propTypes = {
  /** Text on button */
  buttonLabel: PropTypes.string,

  /** Additional class name */
  className: PropTypes.string,

  /** */
  itemsIn: PropTypes.array,

  /** */
  itemsOut: PropTypes.array,

  /** Ref for list */
  listRef: PropTypes.any,

  /** Callback function */
  onHover: PropTypes.func,

  /** */
  onIncreaseDistance: PropTypes.func,

  /** */
  resultMessageIn: PropTypes.string.isRequired,

  /** */
  resultMessageOut: PropTypes.string
};
ResultList.defaultProps = {
  itemsIn: [],
  itemsOut: [],
  onIncreaseDistance: function onIncreaseDistance() {
    return void 0;
  },
  onHover: function onHover() {
    return void 0;
  }
};

module.exports = ResultList;
